import React, { useEffect } from 'react';
import { DynamicButtonInfo } from '../hooks/useQuillEditor';
import ToolbarButton from './ToolbarButton';

interface ToolbarButtonsRendererProps {
  dynamicButtonRoots: DynamicButtonInfo[];
  activeFormats: Record<string, any>;
  quillInstance: any;
}

const ToolbarButtonsRenderer: React.FC<ToolbarButtonsRendererProps> = ({
  dynamicButtonRoots,
  activeFormats,
  quillInstance,
}) => {
  useEffect(() => {
    if (!quillInstance || !dynamicButtonRoots.length) {
      return;
    }

    const toolbarModule = quillInstance.getModule('toolbar') as any;
    if (
      !toolbarModule?.container ||
      !(toolbarModule.container instanceof HTMLElement) ||
      !toolbarModule.container.isConnected
    ) {
      return;
    }

    dynamicButtonRoots.forEach((info) => {
      const { root, buttonElement, iconKey, formatAction, checkActive } = info;

      if (!buttonElement.isConnected || !root) {
        return;
      }

      const isActive = checkActive(activeFormats);

      root.render(
        <ToolbarButton
          iconKey={iconKey as string}
          isActive={isActive}
          onClick={() => {
            if (quillInstance) {
              formatAction(quillInstance, isActive);
              quillInstance.focus();
            }
          }}
        />,
      );
    });
  }, [activeFormats, dynamicButtonRoots, quillInstance]);

  return null; // This component only renders into existing DOM nodes
};

export default ToolbarButtonsRenderer;
